import React from "react";

type Props = {
  id?: string;
};

export const InvoiceHeader: React.FC<Props> = (props) => {
  const { id } = props;

  return (
    <div className="flex flex-row items-center font-source-serif text-5xl">
      Invoice #{id}
    </div>
  );
};
